export default "__VITE_ASSET__ChFPF4pa__"